import { NgModule } from '@angular/core';
import { RouterModule, Routes, RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';

export class NoReuseStrategy implements RouteReuseStrategy {
  shouldDetach(_route: ActivatedRouteSnapshot): boolean { return false; }
  store(_route: ActivatedRouteSnapshot, _handle: DetachedRouteHandle | null): void {}
  shouldAttach(_route: ActivatedRouteSnapshot): boolean { return false; }
  retrieve(_route: ActivatedRouteSnapshot): DetachedRouteHandle | null { return null; }
  shouldReuseRoute(_future: ActivatedRouteSnapshot, _curr: ActivatedRouteSnapshot): boolean { return false; }
}
import { HomeComponent } from './home/home.component';
import { ReadingComponent } from './reading/reading.component';
import { ReportingComponent } from './reporting/reporting.component';
import { CharityDetailsComponent } from './charity-details/charity-details.component';
import { AdminUsersComponent } from './admin-users/admin-users.component';
import { ProbateListComponent } from './probate-list/probate-list.component';
import { AdminClientsComponent } from './admin-clients/admin-clients.component';
import { AdminBeneficiariesComponent } from './admin-beneficiaries/admin-beneficiaries.component';  
import { AdminClientSubscriptionsComponent } from './admin-client-subscriptions/admin-client-subscriptions.component';
import { AdminSubscriptionItemsComponent } from './admin-subscription-items/admin-subscription-items.component';
import { AdminUtilitiesComponent } from './admin-utilities/admin-utilities.component';
import { AdminToolsComponent } from './admin-tools/admin-tools.component';
import { HmrcWillsReportComponent } from './hmrc-wills-report/hmrc-wills-report.component';
import { ClientPortalLoginComponent } from './client-portal-login/client-portal-login.component';
import { ClientPortalComponent } from './client-portal/client-portal.component';
import { ClientPortalResetPasswordComponent } from './client-portal-reset-password/client-portal-reset-password.component';
import { FinanceInvoiceReportComponent } from './finance-invoice-report/finance-invoice-report.component';
import { ProbateStatusReportComponent } from './probate-status-report/probate-status-report.component';
import { AdminPricingComponent } from './admin-pricing/admin-pricing.component';
import { AdminClientTierComponent } from './admin-client-tier/admin-client-tier.component';
import { AdminPaygComponent } from './admin-payg/admin-payg.component';
import { FeedbackReportComponent } from './feedback-report/feedback-report.component';
import { ProductivityReportComponent } from './productivity-report/productivity-report.component';
import { AllocationComponent } from './allocation/allocation.component';
import { PaygPaymentSuccessComponent } from './admin-payg/payg-payment-success/payg-payment-success.component';
import { PaygPaymentFailedComponent } from './admin-payg/payg-payment-failed/payg-payment-failed.component.';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'reading/:id', component: ReadingComponent },
  { path: 'reporting/:id', component: ReportingComponent },
  { path: 'probate-list', component: ProbateListComponent },
  { path: 'charity-details', component: CharityDetailsComponent },
  { path: 'admin-users', component: AdminUsersComponent },
  { path: 'admin-clients', component: AdminClientsComponent },
  { path: 'admin-clients/:clientId/subscriptions', component: AdminClientSubscriptionsComponent },
  { path: 'subscriptions/:subscriptionId/items', component: AdminSubscriptionItemsComponent },
  { path: 'admin-beneficiaries', component: AdminBeneficiariesComponent },
  { path: 'admin-payg', component: AdminPaygComponent },
  { path: 'admin-payg', component: AdminPaygComponent },
  { path: 'admin-payg/payment-success', component: PaygPaymentSuccessComponent },
  { path: 'admin-payg/payment-failed', component: PaygPaymentFailedComponent },
  { path: 'admin-utilities', component: AdminUtilitiesComponent },
  { path: 'admin-tools', component: AdminToolsComponent },
  { path: 'admin-pricing', component: AdminPricingComponent },
  { path: 'admin-client-tier', component: AdminClientTierComponent },
  { path: 'finance/invoice-report', component: FinanceInvoiceReportComponent },
  { path: 'reports/hmrc-wills', component: HmrcWillsReportComponent },
  { path: 'reports/probate-status', component: ProbateStatusReportComponent },
  { path: 'reports/productivity', component: ProductivityReportComponent },
  { path: 'allocation', component: AllocationComponent },
  { path: 'feedback', component: FeedbackReportComponent },
  { path: 'client', component: ClientPortalLoginComponent },
  { path: 'client/reset-password/:token', component: ClientPortalResetPasswordComponent },
  { path: 'client/:clientId', component: ClientPortalComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
